import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { navigation } from '../data/navigation';

function HeaderNavItem({ item, mobile, expanded, onToggle, onNavigate }) {
  const location = useLocation();
  const hasChildren = Boolean(item.children && item.children.length);
  const isActive = location.pathname === item.path;

  if (!hasChildren) {
    return (
      <li className="wsite-menu-item-wrap" id={isActive ? 'active' : undefined}>
        <NavLink
          to={item.path}
          className="wsite-menu-item"
          onClick={onNavigate}
        >
          {item.label}
        </NavLink>
      </li>
    );
  }

  if (!mobile) {
    return (
      <li className="wsite-menu-item-wrap" id={isActive ? 'active' : undefined}>
        <NavLink
          to={item.path}
          className="wsite-menu-item"
          onClick={onNavigate}
        >
          {item.label}
        </NavLink>
        <span className="wsite-menu-arrow">&gt;</span>
        <div className="wsite-menu-wrap" style={{ display: 'none', position: 'absolute' }}>
          <ul className="wsite-menu">
            {item.children.map((child) => (
              <li key={child.path} className="wsite-menu-subitem-wrap">
                <NavLink to={child.path} className="wsite-menu-subitem" onClick={onNavigate}>
                  <span className="wsite-menu-title">{child.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </li>
    );
  }

  return (
    <li className={`wsite-menu-item-wrap${expanded ? ' menu-open-submenu' : ''}`}>
      <div className="mobile-item-row">
        <NavLink
          to={item.path}
          className="wsite-menu-item"
          onClick={onNavigate}
        >
          {item.label}
        </NavLink>
        <button type="button" className="wsite-menu-mobile-arrow mobile-arrow-button" aria-expanded={expanded} onClick={() => onToggle(item.label)}>
          &gt;
        </button>
      </div>
      <div className="wsite-menu-wrap" style={{ display: 'none', position: 'static' }}>
        <ul className="wsite-menu">
          <li className="wsite-menu-back-item">
            <button type="button" className="wsite-menu-mobile-arrow mobile-back-button" onClick={() => onToggle(item.label)}>
              <span className="wsite-menu-back">Back</span>
            </button>
          </li>
          <li className="wsite-menu-master-item">
            <NavLink to={item.path} className="wsite-menu-item" onClick={onNavigate}>
              {item.label}
            </NavLink>
          </li>
          {item.children.map((child) => (
            <li key={child.path} className="wsite-menu-subitem-wrap">
              <NavLink to={child.path} className="wsite-menu-subitem" onClick={onNavigate}>
                <span className="wsite-menu-title">{child.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
}

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);

  useEffect(() => {
    document.body.classList.toggle('menu-open', mobileOpen);
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [mobileOpen]);

  const closeMobileMenu = () => {
    setMobileOpen(false);
    setExpandedItem(null);
  };

  return (
    <div id="header" className="minimal">
      <div className="header-wrap">
        <div className="logo">
          <button
            id="nav-trigger"
            className="hamburger"
            type="button"
            aria-label="Menu"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((value) => !value)}
          >
            <span />
          </button>
          <span className="wsite-logo">
            <Link to="/" onClick={closeMobileMenu}>
              <img src="/uploads/1/1/9/7/119720466/editor/recycla.png?1527653770" alt="Recycla Chile" />
            </Link>
          </span>
        </div>

        <div id="nav" className="menu">
          <ul className="wsite-menu-default">
            {navigation.map((item) => (
              <HeaderNavItem key={item.path} item={item} onNavigate={closeMobileMenu} mobile={false} />
            ))}
          </ul>
        </div>

        <div id="navmobile" className={`menu${mobileOpen ? ' is-open' : ''}`}>
          <ul className="wsite-menu-default">
            {navigation.map((item) => (
              <HeaderNavItem
                key={item.path}
                item={item}
                mobile
                expanded={expandedItem === item.label}
                onToggle={(label) => setExpandedItem((current) => (current === label ? null : label))}
                onNavigate={closeMobileMenu}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
